import { Component, OnInit } from '@angular/core';
import { TranslateService } from 'ng2-translate/ng2-translate';
@Component({
  selector: 'app-general',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.scss']
})
export class ManualComponent implements OnInit {
  //txtHeader = 'Bienvenido';
  language='es';
  constructor(public translate: TranslateService) {
    const idioma = localStorage.getItem('language');


    //this.txtHeader = (idioma=='es') ? 'Bienvenido':'Welcome';

    this.language = idioma;
    translate.use(idioma);
   }

  ngOnInit() {
  }

}
